import React, { useState } from 'react';
import { 
    FormControl, Form, Button, 
    Container, Col, Row
} from 'react-bootstrap';
import PetAndOwnerModel from '../util/Models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faMobileAlt, faPaw } from '@fortawesome/free-solid-svg-icons'

function CreateNewOwnerAndPet(props) {
    const [validated, setValidated] = useState(false);
    const [givenname, setGivenname] = useState('');
    const [surname, setSurname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [petName, setPetName] = useState('');
    const [type, setType] = useState('');
    const [race, setRace] = useState('');

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            event.stopPropagation();
            let customer = {
                givenname: givenname,
                surname: surname,
                phone: phone,
                email: email,
                petName: petName,
                type: type,
                race: race
            }
            const query = `/api/ownerAndPet`;
            var res = await fetch(query,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    cors: 'cors',
                    body: JSON.stringify(customer)
                });
            const resJson = await res.json();
            const selection = new PetAndOwnerModel(
                resJson.OwnerId, 
                `${givenname} ${surname}`, 
                resJson.PetId, 
                petName
            );
            props.onSaved(selection);
        }
        setValidated(true);
    };

    if (!props.shown) {
        return <React.Fragment />;
    }
    else {
        return (
            <Container>
                <Row className="justify-content-md-center">
                    <Col xs={0} md={3}></Col>
                    <Col xs={12} md={6} className="text-center">
                        <h2>Skapa ny kund &amp; djur</h2>
                    </Col>
                    <Col xs={0} md={3}></Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col xs={0} md={3}></Col>
                    <Col xs={12} md={6} className="text-center">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Form.Group>
                                <Row className="align-items-center justify-content-center">
                                    <Col xs={2}>
                                        <FontAwesomeIcon icon={faUserCircle} size="lg"></FontAwesomeIcon>
                                    </Col>
                                    <Col xs={10}>
                                        <FormControl
                                            required={true}
                                            label="Förnamn"
                                            value={givenname}
                                            onChange={(e) => setGivenname(e.target.value)}
                                            type="text"
                                            placeholder="Ange kundens förnamn">
                                        </FormControl>
                                    </Col>
                                </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faUserCircle} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={true}
                                        label="Efternamn"
                                        value={surname}
                                        onChange={(e) => setSurname(e.target.value)}
                                        type="text"
                                        placeholder="Ange kundens efternamn">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faEnvelope} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={false}
                                        label="E-post"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        placeholder="Ange kundens e-post">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faMobileAlt} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={false}
                                        label="Telefon"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        type="text"
                                        placeholder="Ange kundens telefonnummer">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faPaw} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={true}
                                        label="Djurnamn"
                                        value={petName}
                                        onChange={(e) => setPetName(e.target.value)}
                                        type="text"
                                        placeholder="Ange djurets namn">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faPaw} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={true}
                                        label="Djurslag"
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                        type="text"
                                        placeholder="Ange djurslag">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Form.Group>
                            <Row className="align-items-center justify-content-center">
                                <Col xs={2}>
                                    <FontAwesomeIcon icon={faPaw} size="lg"></FontAwesomeIcon>
                                </Col>
                                <Col xs={10}>
                                    <FormControl
                                        required={false}
                                        label="Ras"
                                        value={race}
                                        onChange={(e) => setRace(e.target.value)}
                                        type="text"
                                        placeholder="Ange ras">
                                    </FormControl>
                                </Col>
                            </Row>
                            </Form.Group>
                            <Button size="lg" variant="book" type="submit">
                                Spara
                            </Button>
                        </Form>
                    </Col>
                    <Col xs={0} md={3}></Col>
                </Row>
            </Container>
        );
    } 
}

export default CreateNewOwnerAndPet;